import React from 'react';

/**
 * Standing compliance disclaimer for a finance app.
 * `variant="compact"` renders a single slim line (e.g. under the chat input);
 * default renders a slightly larger footer block for scrollable pages.
 */
const Disclaimer = ({ variant = 'footer' }) => {
  const text =
    'DeepDime provides data-driven analysis for informational purposes only. ' +
    'It is not financial advice. Do your own research or consult a licensed advisor before investing.';

  const base = {
    color: 'var(--disclaimer-color, #7c8598)',
    fontSize: variant === 'compact' ? '11px' : '12px',
    lineHeight: 1.5,
    textAlign: 'center',
    maxWidth: '640px',
    margin: '0 auto',
    padding: variant === 'compact' ? '6px 12px' : '18px 16px',
  };

  return (
    <p className={`app-disclaimer app-disclaimer--${variant}`} style={base}>
      {text}
    </p>
  );
};

export default Disclaimer;
